export const USER_PROFILE = {
  TUTOR: 'Tutor',
  TEACHER: 'Teacher',
  SUPERUSER: 'Superuser',
  SUPPORT_STAFF: 'Support',
  PLANNER: 'Planner'
} as const
